/** Normalizes a WGS84 degree reading for form storage (avoids scientific notation). */
export function formatDecimalGpsCoord(n: number): string {
  if (!Number.isFinite(n)) return '';
  return Number(n.toFixed(6)).toString();
}

/** Human-readable decimal-degree pair with stable precision (6 fractional digits). */
export function formatGpsCoordsDisplayLine(lat: string, lon: string): string | null {
  if (!gpsCoordsValid(lat, lon)) return null;
  const latN = Number.parseFloat(String(lat).trim().replace(',', '.'));
  const lonN = Number.parseFloat(String(lon).trim().replace(',', '.'));
  return `${formatDecimalGpsCoord(latN)}, ${formatDecimalGpsCoord(lonN)}`;
}

/** Rounded GPS horizontal accuracy for UI (meters). */
export function formatGpsAccuracyMeters(accuracyMeters: number): string {
  if (!Number.isFinite(accuracyMeters) || accuracyMeters <= 0) return '';
  if (accuracyMeters < 10) return accuracyMeters.toFixed(1);
  return String(Math.round(accuracyMeters));
}

/** True when latitude/longitude strings parse to finite WGS84 coordinates. */
export function gpsCoordsValid(lat: string, lon: string): boolean {
  const latN = Number.parseFloat(String(lat).trim().replace(',', '.'));
  const lonN = Number.parseFloat(String(lon).trim().replace(',', '.'));
  if (!Number.isFinite(latN) || !Number.isFinite(lonN)) return false;
  if (latN < -90 || latN > 90 || lonN < -180 || lonN > 180) return false;
  return true;
}
